var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVacancyLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22.5 22.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.2 10.8C9.4 10.8 8 9.3 8 7.5s1.5-3.3 3.3-3.3 3.3 1.5 3.3 3.3c-.1 1.8-1.5 3.3-3.4 3.3m0-10.8C7.1 0 3.8 3.4 3.8 7.5c0 4 6.8 14.4 7.1 14.8.1.2.4.3.6.1.1 0 .1-.1.1-.1.3-.4 7.1-10.8 7.1-14.8 0-4.1-3.3-7.5-7.5-7.5"
  })));
}

export default __webpack_public_path__ + "e2688a10d0403ec03e5f2487770ab1a5.svg";
export { SvgVacancyLocation as ReactComponent };